<template>
  <Expired
    :title="$t('payment.error_title')"
    :text="$t('payment.error_text')"
  ></Expired>
</template>

<script>
import Expired from "@/components/auth/Expired";

export default {
  components: {
    Expired,
  },
};
</script>
